/*
 * Report helpers kept pure so row-building stays easy to test and reuse.
 */
export const toNumber = value => Number.parseFloat(value ?? 0) || 0

export const toDlrPercentage = (delivered, total) => {
  const _total = toNumber(total)

  return !_total ? "0%" : `${((toNumber(delivered) / _total) * 100).toFixed(2)}%`
}

export const formatMoney = value => toNumber(value).toFixed(2)

export const toAlphabetLabel = index => {
  let label = ""
  let current = index + 1

  while (current > 0) {
    const remainder = (current - 1) % 26
    label = `${String.fromCharCode(97 + remainder)}${label}`
    current = Math.floor((current - 1) / 26)
  }

  return `${label}.`
}

export const getReportBody = marginReport => marginReport?._report ?? {}

export const getReportTotals = marginReport => marginReport?.marginTotals ?? {}

export const getAccountReport = (report, accountId) => report?.[accountId] ?? {}

export const buildDestinationRows = (report, accountId) =>
  Object.entries(getAccountReport(report, accountId))
    .map(([countryName, item]) => ({
      countryName,
      totalsmscount: toNumber(item?.totalsmscount),
      totaldelivered: toNumber(item?.totaldelivered),
      totalfailed: toNumber(item?.totalfailed),
      totalaccepted: toNumber(item?.totalaccepted),
      dlrPercentage: toDlrPercentage(item?.totaldelivered, item?.totalsmscount),
      revenue: toNumber(item?.revenue),
      cost: toNumber(item?.cost),
      margin: toNumber(item?.margin),
    }))
    .sort((a, b) => a.countryName.localeCompare(b.countryName))

export const buildTrunkTotals = destinations =>
  destinations.reduce(
    (acc, item) => ({
      totalSms: acc.totalSms + item.totalsmscount,
      delivered: acc.delivered + item.totaldelivered,
      failed: acc.failed + item.totalfailed,
      accepted: acc.accepted + item.totalaccepted,
      revenue: acc.revenue + item.revenue,
      cost: acc.cost + item.cost,
      margin: acc.margin + item.margin,
    }),
    { totalSms: 0, delivered: 0, failed: 0, accepted: 0, revenue: 0, cost: 0, margin: 0 },
  )

export const mergeAccountsWithReportKeys = (accounts, report) => {
  const accountsById = {}

  for (const account of accounts ?? []) {
    if (account?.id) accountsById[account.id] = account
  }

  for (const accountId of Object.keys(report ?? {})) {
    if (!accountsById[accountId]) accountsById[accountId] = { id: accountId }
  }

  return Object.values(accountsById)
}

export const getAccountDisplayName = account =>
  account?.displayName?.split("(")?.[0]?.trim() || "-"
